import {Component, Input} from '@angular/core';
import {WidgetModel} from '../../model/widget.model';
import {Router} from '@angular/router';

@Component({
    selector: 'app-edi-files-widget',
    templateUrl: './edi-files-widget.component.html',
    styleUrl: './edi-files-widget.component.scss'
})
export class AppEdiFilesWidgetComponent {
    @Input() widgetData: WidgetModel;

    constructor(
        private router: Router
    ) {
    }

    navigateTo(url: string): void {
        void this.router.navigate([url]);
    }
}